module.exports = __webpack_public_path__ + "img/botao_base_metropolitana.251f2f4b.png";